/**
 * お知らせ エンティティ
 */
import { isNud } from '@/shared/utilities/typing'
import Target from '@/shared/models/enums/target'
import { dateYmd } from '@/shared/utilities/date-format'

class Article {
    article_id;
    target;
    article_date;
    article_title;
    article_content;
    article_content_html;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.article_id = properties.article_id;
        this.target = properties.target;
        this.article_date = properties.article_date;
        this.article_title = properties.article_title;
        this.article_content = properties.article_content;
        this.article_content_html = properties.article_content_html;
    }

    get target_display() {
        return Target.get(this.target);
    }

    get article_date_display() {
        return dateYmd(this.article_date, '');
    }
}

export default Article;
